import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Input,
  Tooltip,
  Image,
  Select,
  DatePicker,
  Tag,
  Space,
  Modal,
  Form,
} from "antd";
import React, { useState, useEffect, useContext } from "react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import useDebounce from "../../hooks/useDebounce";
import { useNavigate, useLocation } from "react-router";
import apiPath from "../../constants/apiPath";
import ShowTotal from "../../components/ShowTotal";
import lang from "../../helper/lang";
import moment from "moment";
import { ExclamationCircleOutlined, UndoOutlined } from "@ant-design/icons";
import FilterBar, { FilterBarFilters } from "../../components/FilterBar";
import confirm from "antd/lib/modal/confirm";
import ViewGroup from "./ViewGroup";
import { AuthContext } from "../../context/AuthContext";
import { USERTYPE } from "../../constants/conts";
const Search = Input.Search;
const { Option } = Select;
const { RangePicker } = DatePicker;

function Index() {
  const sectionName = lang("Group");

  const [groupModal, setGroupModal] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState("");
  const location = useLocation();
  const [groupId, setGroupId] = useState("");
  const [searchText, setSearchText] = useState("");
  const [reportStatus, setReportStatus] = useState("");
  const navigate = useNavigate();
  const { request } = useRequest();
  const [list, setList] = useState([]);
  const [selected, setSelected] = useState();
  const [visible, setVisible] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isChangeAdminModal, setIsChangeAdminModal] = useState(false);
  const [startDate, setStartDate] = useState();
  const [regions, setRegions] = useState([]);

  const [endDate, setEndDate] = useState();
  const [form] = Form.useForm();
  const [statusModalOpen, setStatusModalOpen] = useState(false);
  const [selectedPost, setSelectedPost] = useState({
    id: null,
    status: null,
  });

  const [filters, setFilters] = useState({
    status: null,
  });
  const [showFilters, setShowFilters] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const debouncedSearchText = useDebounce(searchText, 300);

  const view = (id) => {
    navigate(`/user/customer/view/${id}`);
  };

  const columns = [
    {
      title: "Group Name",
      dataIndex: "name",
      key: "name",
      render: (_, { name, image, _id }) => {
        return (
          <div className="main-new-image-and-text-oki9profile">
            {image ? (
              <Image className="image-index-radius" src={image} />
            ) : (
              <span className="image-fallback">
                {name ? name.charAt(0).toUpperCase() : "N/A"}
              </span>
            )}
            <a className="cap avatar-text column-avatar-text">
              {name ? name : "N/A"}
            </a>
          </div>
        );
      },
    },
    {
      title: "Group Admin",
      dataIndex: "adminDetails",
      key: "adminsDetails",
      render: (_, { adminsDetails }) => {
        return adminsDetails && adminsDetails.length > 0
          ? adminsDetails.map((admin) => admin.name).join(", ")
          : "-";
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (_, { status, _id }) => {
        let color =
          status === "APPROVED"
            ? "green"
            : status === "PENDING"
              ? "yellow"
              : "red";
        return (
          <a>
            <Tag
              onClick={() => handleOpenStatus(_id, status)}
              color={color}
              key={status}
            >
              {status === "APPROVED"
                ? "Approved"
                : status === "PENDING"
                  ? "Pending"
                  : "Disabled"}
            </Tag>
          </a>
        );
      },
    },
    {
      title: "Activity Level",
      dataIndex: "activityLevel",
      key: "activityLevel",
      render: (activityLevel) => {
        let color =
          activityLevel === "HIGH"
            ? "green"
            : activityLevel === "LOW"
              ? "yellow"
              : "red";
        return (
          <a>
            <Tag color={color} key={activityLevel}>
              {activityLevel === "HIGH"
                ? "High"
                : activityLevel === "LOW"
                  ? "Low"
                  : "Inactive"}
            </Tag>
          </a>
        );
      },
    },
    {
      title: "Region",
      dataIndex: "location",
      key: "location",
      render: (_, { location }) => {
        return location && location.state ? location.state : "N/A";
      },
    },
    {
      title: "Group Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (_, { createdAt }) => {
        return moment(createdAt).format("DD-MM-YYYY, HH:mm a") || "-";
      },
    },
    {
      title: `Action`,
       
      render: (_, record) => {
        return (
          <>
            <div className="main-new-jh-tool">
              <Tooltip
                title={`View ` + sectionName}
                color={"purple"}
                key={"veiwGroup"}
              >
                <Button
                  onClick={() => {
                    setGroupId(record._id);
                    setGroupModal(true);
                  }}
                >
                  <i className="fa fa-light fa-eye"></i>
                </Button>
              </Tooltip>
              <Tooltip
                title={
                  isUpdatePermissionGranted
                    ? `Change  Admin`
                    : "You have not permission"
                }
                color={"purple"}
                key={"change-admin"}
              >
                <Button
                  onClick={() => {
                    setSelectedGroup(record);
                    setIsChangeAdminModal(true);
                  }}
                  disabled={!isUpdatePermissionGranted}
                >
                  <i className="fa fa-light fa-edit"></i>{" "}
                </Button>
              </Tooltip>

              <Tooltip
                title={
                  isDeletePermissionGranted
                    ? `Delete Group `
                    : "You have not permission"
                }
                color={"purple"}
                key={"delete"}
              >
                <Button
                  onClick={() => handleDeleteGroup(record._id)}
                  disabled={!isDeletePermissionGranted}
                >
                  <i className="fa fa-light fa-trash"></i>{" "}
                </Button>
              </Tooltip>
            </div>
          </>
        );
      },
    },
  ];

  const fetchData = (
    pagination,
    filters,
    sorter = { columnKey: "", order: "" },
  ) => {
    const params = new URLSearchParams();
    if (filters.status) {
      params.append("status", filters.status);
    }
    if (debouncedSearchText) {
      params.append("search", debouncedSearchText);
    }

    if (startDate) {
      params.append("startDate", startDate);
    }
    if (endDate) {
      params.append("endDate", endDate);
    }

    if (filters.region) {
      params.append("region", filters.region);
    }

    if (filters.activityLevel) {
      params.append("activityLevel", filters.activityLevel);
    }
    // 📄 Pagination
    params.append("page", pagination.current);
    params.append("limit", pagination.pageSize);
    request({
      url: `${apiPath.listGroups}?${params.toString()}`,
      method: "GET",
      onSuccess: (data) => {
        setLoading(false);
        setList(data.data.data);
        setPagination(() => ({
          current: pagination.current,
          total: data.data.total,
          pageSize: data.data.limit,
        }));
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const fetchRegions = () => {
    request({
      url: `${apiPath.listRegions}`,
      method: "GET",
      onSuccess: ({ data }) => {
        setLoading(false);
        setRegions(data?.data);
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const handleChange = (pagination, filters, sorter) => {
    fetchData(pagination, filters, sorter);
  };

  const handleFinish = (values) => {
    try {
      const userId = values.admin;
      request({
        url: `${apiPath.changeGroupAdmin}/${selectedGroup._id}`,
        method: "PUT",
        data: { userId },
        onSuccess: (data) => {
          fetchData(pagination, filters);
          ShowToast(
            `${data.message || "Update Admin Successfully"}`,
            Severty.SUCCESS,
          );
          setIsChangeAdminModal(false);
        },
        onError: (error) => {
          const message = error.response.data.message;
          setLoading(false);
          ShowToast(message, Severty.ERROR);
        },
      });
    } catch (error) {
      ShowToast(error.message, Severty.ERROR);
    }
  };

  const handleFilterChange = (filterName, value) => {
    setFilters((prev) => ({ ...prev, [filterName]: value }));
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  const onSearch = (e) => {
    setSearchText(e.target.value);
    setPagination({ current: 1, pageSize: pagination.pageSize });
  };

  const resetData = () => {
    setSearchText("");
    setStartDate("");
    setEndDate("");
    setFilters({
      status: null,
      category: null,
    });
    setRefresh((prev) => !prev);
  };

  const handleChangeDate = (e) => {
    setPagination({ current: 1, pageSize: pagination.pageSize });
    if (e != null) {
      setStartDate(moment(e[0]._d).format("YYYY-MM-DD"));
      setEndDate(moment(e[1]._d).format("YYYY-MM-DD"));
    } else {
      setStartDate();
      setEndDate();
    }
  };

  const handleDeleteGroup = (id) => {
    setTimeout(() => {
      confirm({
        maskClosable: true,
        icon: <ExclamationCircleOutlined />,
        className: "tab_modal",
        cancelButtonProps: { color: "red" },
        content: (
          <p
            style={{
              fontSize: "24px",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            Are you sure you want to delete this group permanently ?
          </p>
        ),
        onOk() {
          request({
            url: `${apiPath.deleteGroup}/${id}`,
            method: "DELETE",
            data: {},
            onSuccess: (data) => {
              fetchData(pagination, filters);
              ShowToast(
                `${data.message || "Status Changed Successfully"}`,
                Severty.SUCCESS,
              );
            },
            onError: (error) => {
              const message = error.response.data.message;
              setLoading(false);
              ShowToast(message, Severty.ERROR);
            },
          });
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    }, 5);
  };

  const handleOpenStatus = (id, currentStatus) => {
    setSelectedPost({ id, status: currentStatus });
    setStatusModalOpen(true);
  };

  const handleStatus = (id, status) => {
    request({
      url: `${apiPath.changeGroupStatus}/${id}`,
      method: "PUT",
      data: { status },
      onSuccess: (data) => {
        setStatusModalOpen(false);
        fetchData(pagination, filters);
        ShowToast(
          `${data.message || "Status Changed Successfully"}`,
          Severty.SUCCESS,
        );
      },
    });
  };

  // ------------ Module Permissions ------------

  const { userProfile, userPermission } = useContext(AuthContext);
  const isSuperAdmin = userProfile?.role === USERTYPE.SUPER_ADMIN;

  const isUpdatePermissionGranted =
    isSuperAdmin ||
    (userPermission?.GROUP_MANAGER?.enabled === true &&
      userPermission.GROUP_MANAGER.permissions.update === true);
  const isDeletePermissionGranted =
    isSuperAdmin ||
    (userPermission?.GROUP_MANAGER?.enabled === true &&
      userPermission.GROUP_MANAGER.permissions.delete === true);

  // --------------- Use Effects ---------------
  useEffect(() => {
    setLoading(true);
    fetchData(pagination, filters);
  }, [filters, refresh, debouncedSearchText, startDate, endDate, reportStatus]);

  // Open View Group modal if navigated from GlobalSearch with a groupId
  useEffect(() => {
    if (location.state && location.state.groupId) {
      setGroupId(location.state.groupId);
      setGroupModal(true);
    }
    if (location.state && location.state.groupName) {
      setSearchText(location.state.groupName);
    }
    if (location.state && location.state?.activityLevel) {
      handleFilterChange("activityLevel", location.state?.activityLevel);
    }
  }, [location.state]);

  useEffect(() => {
    fetchRegions();
  }, []);

  return (
    <>
      <div className="tabled">
        <ViewGroup
          open={groupModal}
          onClose={() => setGroupModal(false)}
          groupId={groupId}
        />
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title={sectionName + ` ${lang("Manager")}`}
              extra={
                <FilterBar
                  showFilters={showFilters}
                  onToggle={() => setShowFilters((v) => !v)}
                  searchContent={
                    <Search
                      size="large"
                      onChange={onSearch}
                      value={searchText}
                      onPressEnter={onSearch}
                      allowClear
                      placeholder={`${lang("Search")} ${lang(
                        "By User Name or Mobile Number",
                      )}`}
                    />
                  }
                />
              }
            >
              {showFilters && (
                <FilterBarFilters>
                  <Select
                    placeholder="Status"
                    value={filters.status}
                    onChange={(value) => handleFilterChange("status", value)}
                    allowClear
                  >
                    <Option value="PENDING">Pending</Option>
                    <Option value="APPROVED">Approved</Option>
                    <Option value="DISABLED">Disable</Option>
                  </Select>
                  <Select
                    placeholder="Regions"
                    value={filters.region}
                    allowClear
                    onChange={(value) => handleFilterChange("region", value)}
                  >
                    {regions.map((region) => (
                      <Option key={region} value={region}>{region}</Option>
                    ))}
                  </Select>
                  <Select
                    placeholder="Activity Level"
                    value={filters.activityLevel}
                    onChange={(value) =>
                      handleFilterChange("activityLevel", value)
                    }
                    allowClear
                  >
                    <Option value="HIGH">High</Option>
                    <Option value="LOW">Low</Option>
                    <Option value="INACTIVE">Inactive</Option>
                  </Select>
                  <RangePicker
                    disabledDate={(current) =>
                      current && current.isAfter(moment().endOf("day"))
                    }
                    onChange={handleChangeDate}
                    value={
                      startDate && endDate
                        ? [moment(startDate), moment(endDate)]
                        : null
                    }
                  />
                  <Button
                    onClick={() => resetData()}
                    type="primary"
                    icon={<UndoOutlined />}
                  >
                    Reset
                  </Button>
                </FilterBarFilters>
              )}
              <h4 className="text-right mb-1">
                {pagination.total ? ShowTotal(pagination.total) : ShowTotal(0)}
              </h4>
              <div className="table-responsive customPagination">
                <Table
                  loading={loading}
                  columns={columns}
                  dataSource={list}
                  pagination={{
                    current: pagination.current,
                    defaultPageSize: 10,
                    responsive: true,
                    total: pagination.total,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    pageSizeOptions: ["10", "20", "30", "50"],
                  }}
                  onChange={handleChange}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>

      {/* Status Update Modal */}
      <Modal
        open={statusModalOpen}
        footer={null}
        centered
        closable
        onCancel={() => setStatusModalOpen(false)}
      >
        <div style={{ textAlign: "center" }}>
          <p style={{ fontSize: 22, fontWeight: "bold", marginBottom: 20 }}>
            Update Group Status
          </p>

          <Space size="middle">
            {selectedPost.status !== "APPROVED" && (
              <Button
                type="primary"
                style={{ background: "#52c41a", borderColor: "#52c41a" }}
                onClick={() => handleStatus(selectedPost.id, "APPROVED")}
              >
                Approved
              </Button>
            )}

            {selectedPost.status !== "pending" && (
              <Button
                type="primary"
                style={{ background: "#faad14", borderColor: "#faad14" }}
                onClick={() => handleStatus(selectedPost.id, "pending")}
              >
                Pending
              </Button>
            )}

            {selectedPost.status !== "disabled" && (
              <Button
                type="primary"
                danger
                onClick={() => handleStatus(selectedPost.id, "disabled")}
              >
                Disable
              </Button>
            )}
          </Space>
        </div>
      </Modal>

      {/* Update Admin Modal */}
      <Modal
        width={500}
        open={isChangeAdminModal}
        title={`Change Admin`}
        okText={`Update`}
        cancelText={`Cancel`}
        onCancel={() => setIsChangeAdminModal(false)}
        okButtonProps={{
          form: "create",
          htmlType: "submit",
          loading: loading,
        }}
      >
        <Form id="create" form={form} onFinish={handleFinish} layout="vertical">
          <Row gutter={{ xs: [0, 16], md: [16, 0] }}>
            <Col span={24}>
              <Col span={24} className="main-new-currency-card">
                <Form.Item
                  label="Select Admin"
                  name="admin"
                  rules={[
                    {
                      required: true,
                      message: "Please select an admin!",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select Admin"
                    allowClear
                    showSearch
                    optionFilterProp="children"
                  >
                    {selectedGroup?.membersDetails?.map((member) => (
                      <Select.Option key={member?._id} value={member?._id}>
                        {member?.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
}

export default Index;
